<template>
  <div class="wrapper">
    <Header/>
    <Sidebar @collapse-toggle="sidebarToggle"/>
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Main content -->
      <section class='content-data'>
        <slot/>
      </section>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->

    <Footer/>
  </div>
</template>

<script>
import Header from "@/common/components/HeaderComponent.vue";
import Sidebar from "@/common/components/Sidebar.vue";
import Footer from "@/common/components/FooterComponent.vue";

export default {
  components: {
    Header,
    Sidebar,
    Footer,
  },
  data: () => ({
    isCollapsed: false
  }),
  mounted() {
    this.isCollapsed = document.querySelector('body').classList.contains('sidebar-collapse')
  },
  created() {
    $("body").addClass("hold-transition sidebar-mini layout-fixed");
  },
  methods: {
    sidebarToggle() {
      this.isCollapsed = !this.isCollapsed
      const bodyClasses = document.querySelector('body').classList
      this.isCollapsed ?bodyClasses.remove('sidebar-collapse') :  bodyClasses.add('sidebar-collapse')
    }
  }
};
</script>

<style scoped lang='scss'>
  .content-wrapper{
    display: flex;

    .content-data{
      width: 100%
    }
  }
</style>